import React, { Component } from 'react';
import { Http,urls } from '../../api/index'
import { NavBar, Icon, Toast } from 'antd-mobile'
import * as Order from '../../redux/actions/orderAction'
import NavBarComponent from '../../component/common/NavBarComponent'
import { parseSearchToState, throttle } from '../../util/util';
import { connect } from 'react-redux';
import store from 'store'
import {phoneType} from '../../util/base';
import './pay.scss';

let timer;

const ua = navigator.userAgent;
// 1 Android  2 ios
const iphoneType = phoneType(ua);

class PaymentPage extends Component {
  constructor(props){
    super(props);
    this.pay = parseSearchToState(this.props.history.location.search) || {};
    this.serialNo = ''
    this.state = {
      payType: '',
      paymentInfo: {},
      payMethods: {},
      showPay: [],
      yue: 0
    }
    this.throttlePay = throttle((payType) => this.goPay(payType),5000)
  }
  componentDidMount() {
    this.props.dispatch(Order.orderCouponRemove())
    this.props.dispatch(Order.orderClear())
    this.payTypezf()
    timer = setInterval(()=>{
      this.searchPayResult()
    }, 500)
  }
  componentWillUnmount(){
    clearInterval(timer)
  }
  searchPayResult(){
    let url = urls.searchPayResult;
    let serialNo = this.serialNo || store.get('serialNo')
    if (serialNo){
      let data = {
        serialNo
      }
      Http.post({ url, data }).then(res => {
        if (res.data.tradeStatus === 12) {
          // 调用端上删除 header 方法
          if (store.get('source') === 'app') {
            if (iphoneType === 1) {
              window.izuche.setNeedAddWechatHeader(2);
            } else if (iphoneType === 2) {
              window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                  action: 'removeWechatHeader'
              });
            }
          }
          window.location.replace(`/paysuccess?price=${this.pay.price || ''}`)
        }
      })
   }
  }
  payTypezf() {
    let url = urls.payTypezf;
    let data = {
      bizType: 2, 
      orderNo: this.pay.orderNo, 
      billNo: this.pay.billNo
    };
    Http.post({ url, data }).then(res => {
      if (res.type === 'wechat') {
        // 调用端上删除 header 方法
        if (store.get('source') === 'app') {
          if (iphoneType === 1) {
            window.izuche.setNeedAddWechatHeader(2);
          } else if (iphoneType === 2) {
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                action: 'removeWechatHeader'
            });
          }
        }
        window.location.replace(`/paysuccess?price=${this.pay.price || ''}`)
      }
      let arr = res.data.payMethods.payList.map(item => {
        if (item.payMethod === 0) {
          this.setState({
            yue: item.balance
          })
        }
        return item.payMethod
      })
      this.setState({
        paymentInfo: res.data.paymentInfo,
        payMethods: res.data.payMethods,
        showPay:arr
      })
    })
  }
  goPay(payType) {
    if (payType === '') {
      return Toast.info('暂无支付方式')
    }
    Toast.loading('加载中');
    const payChannel = {yue: 0, wechat: 101, ali: 201}
    const payMethod = {yue: 0, wechat: 1, ali: 2}
    let pay = this.state.paymentInfo
    let url = urls.getPayInfo;
    let data = {
      payChannel: payChannel[payType], 
      payMethod: payMethod[payType], 
      orderNo: pay.orderNo,
      billNo: pay.billNo,
      billPayNo: pay.billTransNo,
      tradeType: pay.tradeType, 
      amount: pay.payAmount,
      billType: pay.financialAmountType
    };
    Http.post({ url, data }).then(res => {
      Toast.hide()
      if (res.type === 'wechat') {
        // 调用端上删除 header 方法
        if (store.get('source') === 'app') {
          if (iphoneType === 1) {
            window.izuche.setNeedAddWechatHeader(2);
          } else if (iphoneType === 2) {
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                action: 'removeWechatHeader'
            });
          }
        }
        window.location.replace(`/paysuccess?price=${this.pay.price || ''}`)
      }
      if (this.state.payType === 'ali') {
        window.location.href = res.data.wapPayUrl
      }
      if ( this.state.payType === 'wechat') {
        // 存储支付流水号，查询支付结果
        store.set('serialNo', res.data.serialNo)
        this.serialNo = res.data.serialNo
        setTimeout(() => {
          // 调用端上添加 header 方法
          if (store.get('source') === 'app') {
            if (iphoneType === 1) {
              window.izuche.setNeedAddWechatHeader(1);
            } else if (iphoneType === 2) {
              window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                  action: 'addWechatHeader'
              });
            }
          }
          window.location.href = res.data.wapPayUrl
        }, 200)
      //   timer = setInterval(()=>{
      //     this.searchPayResult()
      // },200);
      }
      if (this.state.payType === 'yue') {
       res.data.tradeStatus === '13' && Toast.info(res.data.failReason,3,null,false)
       if (res.data.tradeStatus === '12') {
        Toast.info('支付成功', 1, null, false)
        this.props.history.replace(`/routeOrder?orderNo=${this.state.paymentInfo.orderNo||''}`)
       }
      }
    }).catch(e => {
      Toast.hide()
    })
  }
  onPay(payType){
    this.setState({
      payType
    })
    this.throttlePay(payType)
  }
  _header() {
    return <div className='header'>
      <i className='iconfont icon-order'></i>
      <p className='c9 font15 mt10'>下单成功</p>
      <p className='c3 font14 mt20 bold'>订单金额￥{this.state.paymentInfo.payAmount}</p>
      <p className='c9 font12 mt15'>请在1小时内完成支付，超时系统自动取消</p>
    </div>
  }
  _renderList() {
    return <div className='pt20'>
        {this.state.showPay.includes(0) && <div onClick={() => this.onPay('yue')}  className='ccard'>
          <div>
            <i className='iconfont icon-yue font20 yue'></i>
            <span>余额￥{this.state.yue}元</span>
          </div>
          <Icon type='right' color='#999'/>
        </div>}
        {this.state.showPay.includes(0) && <div className='line mt15 mb15'></div>}
        {this.state.showPay.includes(1) && <div onClick={() => this.onPay('wechat')} className='ccard'>
          <div>
            <i className='iconfont icon-wechat font20'></i>
            <span>微信支付</span>
          </div>
          <Icon type='right' color='#999'/>
        </div>}
       {this.state.showPay.includes(2) &&  <div onClick={() => this.onPay('ali')} className='ccard'>
          <div>
            <i className='iconfont icon-ali font20'></i>
            <span>支付宝支付</span>
          </div>
          <Icon type='right' color='#999'/>
        </div>}
    </div>
  }
  render() {
    return <div id='payment' className='page'>
      <NavBarComponent>
        <NavBar 
          icon={<Icon type="left" color='#333' />} 
          onLeftClick={() => {
              clearInterval(timer); 
              store.remove('serialNo');
              setTimeout(() => {
                window.history.go(-1)
                // this.props.history.goBack()
              }, 200)
              }}
          mode='light'>收银台</NavBar>
      </NavBarComponent>
      <div className='content'>
        {this._header()}
        {this._renderList()}
      </div>
    </div>
  }
}
const mapState =  connect(state => {
  const { orderReducer } = state
  return { orderReducer }
});
export default mapState(PaymentPage);